import React from 'react'
import styled from 'styled-components'
import { Paper, View } from '@olxbr/design-system'
import PropTypes from 'prop-types'

import medias from '../../../util/medias'
import TermsAndPrivacyNotice from '../../molecules/TermsAndPrivacyNotice'
import EmailConfirmationSentTemplate from '../../templates/EmailConfirmationSentTemplate'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.small`
    margin-top: 24px;
    margin-bottom: 24px;
    margin-left: 0px;
    margin-right: 0px;
  `}
`

const CustomPaper = styled(Paper)`
  padding: 40px 54px 44px 56px;
`

const TermsAndPrivacyNoticeWrapper = styled(View)`
  margin-top: 24px;
`

export const EmailConfirmationSentPage = ({ email, onEmailClick }) => (
  <Content>
    <CustomPaper>
      <EmailConfirmationSentTemplate email={email} onEmailClick={onEmailClick} />
    </CustomPaper>
    <TermsAndPrivacyNoticeWrapper>
      <TermsAndPrivacyNotice />
    </TermsAndPrivacyNoticeWrapper>
  </Content>
)

EmailConfirmationSentPage.propTypes = {
  email: PropTypes.string.isRequired,
  onEmailClick: PropTypes.func.isRequired,
}
